import React from 'react'
import classNames from 'classnames'
import FreeShipping from './free-shipping.svg'
import Returnable from './returnable.svg'
import PriceTag from './price-tag.svg'
import styles from './styles.css'

interface ProductDisclosuresProps {
  noBorder?: boolean
  isReturnable?: boolean
  hasFreeShipping?: boolean
  className?: string
}

const ProductDisclosures: React.SFC<ProductDisclosuresProps> = ({
  noBorder,
  isReturnable,
  hasFreeShipping,
  className
}) => {
  return (
    <ul
      className={classNames(styles.list, className, {
        [styles.noBorder]: noBorder
      })}
    >
      {hasFreeShipping && (
        <li>
          <FreeShipping className={styles.icon} /> Free shipping
        </li>
      )}
      <li>
        <PriceTag className={styles.icon} /> Price match guarantee
      </li>
      {isReturnable && (
        <li>
          <Returnable className={styles.icon} /> Returnable
        </li>
      )}
    </ul>
  )
}

export default ProductDisclosures
